import React from 'react';

// -- MUI -- //
import Card from '@mui/material/Card';
// import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';

// import { useNavigate } from 'react-router-dom';

function ControlTicket(props) {
  const ticketName = props.ticketName;
  const ticketValue = props.ticketValue;
  const ticketPath = props.ticketPath;
  //const ticketStatus = props.ticketStatus;

  return (
    <Card
      onClick={ticketPath}
      sx={{
        minWidth: 250,
        minHeight: 40,
        borderRadius: 4,
        boxShadow: '2px 6px 5px 0px rgba(0, 0, 0, 0.75)',
        cursor: 'pointer',
      }}
      className='card-ticket'
    >
      <CardContent>
        <Typography
          variant='h2'
          sx={{
            fontSize: 14,
            fontWeight: 600,
            // marginTop: 2,
            textTransform: 'uppercase',
          }}
          color='aliceblue'
          gutterBottom
        >
          {ticketName}
        </Typography>
        <Typography variant='h5' component='div' color='aliceblue'>
          {ticketValue}
        </Typography>
      </CardContent>
      {/* <Button
        size='small'
        onClick={ticketPath}
        disabled={false}
        sx={{ padding: 0 }}
      >
        Open
      </Button> */}
    </Card>
  );
}

export default ControlTicket;
